
import { base_url } from "../services/constants";
import UrlService from "../services/url-service";
import DataStore from "../services/data-store";
import ShopService from "../services/shop-service";
import CollapseIndicator from "../vue-components/collapse-indicator.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import OrderSummaryMini from "../orders/order-summary-mini.vue";
export default {
	components: {
		CollapseIndicator,
		CollapseTransition,
		OrderSummaryMini,
	},
	data() {
		return {
			ShopService,
			UrlService,
			tickets: [],
			loading: false,
			opens: {},
		};
	},
	created() {
		this.refresh();
	},
	methods: {
		refresh() {
			this.loading = true;
			DataStore.get(base_url + "/admin/ticket/tickets?ShopId=" + ShopService.shop.ShopId)
				.then((data) => {
					this.tickets = data.tickets;
					this.opens = {};
				})
				.finally(() => (this.loading = false));
		},
	},
};
